import type { OfferingPayload, OfferingResponse } from '../../types/offerings';
import { getApiConfig } from '../../services/api/utils';
import { OfferingsServiceApiClient } from '@highereducation/offerings';

/**
 * Fetches qualified offerings from the Offerings Service SDK.
 */
export const fetchQualifiedOfferings = async (
  payload: OfferingPayload,
  userIpAddress?: string | null,
): Promise<OfferingResponse> => {
  const config = getApiConfig();
  const baseUrl = config.offeringsSearchApiUrl ?? '';

  const client = new OfferingsServiceApiClient({
    baseUrl,
    defaultHeaders: {
      'content-type': 'application/json',
    },
  });

  const response = await client.getQualifiedOfferings(
    payload,
    userIpAddress ?? null,
  );

  if (!response) {
    throw new Error('Failed to fetch qualified offerings');
  }

  return response as OfferingResponse;
};
